
export interface RefreshData {
    name: string;
    state: any;
}


export class RefreshState {
    static readonly type = '[RefreshData] RefreshState';
    constructor(public data: RefreshData) { }
}
